//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../Routing/Routing.ConnectivityDefinition.js";
let d=[[],[[["n_from_terminals"],"GetFromTerminals",{R_:{from_terminals:"Routing.LogicalTerminal[]"}},0,0],[["n_to_terminals"],"GetToTerminals",{R_:{to_terminals:"Routing.LogicalTerminal[]"}},0,0],[["from_terminals"],"ReplaceFromTerminals",{},1,0],[["to_terminals"],"ReplaceToTerminals",{},1,0],[["from_terminal"],"AddFromTerminal",{R_:{result:''}},1,0],[["from_terminal"],"RemoveFromTerminal",{R_:{result:''}},1,0],[["to_terminal"],"AddToTerminal",{R_:{result:''}},1,0],[["to_terminal"],"RemoveToTerminal",{R_:{result:''}},1,0]],[]];
SPLM.Routing.LogicalConnection = class extends SPLM.Routing.ConnectivityDefinition{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.LogicalConnection";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;